// @ts-nocheck
import React, { useEffect, useState, useMemo } from "react";
import { Button, Input, Drawer, Form, Row, Col, Switch, Table, Select, Menu, Dropdown } from "antd";
import { AddUser } from "@icon-park/react";
import SkipBack from "../../assets/img/skip-back.png";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../docRoutes/docRoutes";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Includes/Header";
import { useFetch } from "../../Services/useFetch";
import { Down, More, Record } from "@icon-park/react";
import { Receipt } from "@mui/icons-material";
import { userInfoAction } from "../../Redux/actions/userInfoAction";
import { fetchAuthMode } from "../../utils/docGridSso";

const showActions = true;
const { Search } = Input;
const { Option } = Select;

const initialstate = {
  firstname: "",
  lastname: "",
  company_id: null,
  email: "",
  contactnumber: "",
  password: "",
  country_id: null,
  state_id: null,
  city_id: null,
  date_of_birth: null,
  full_address_1: "",
  designation_id: "",
  module_id: "",
  zip_code: "",
  profileimg: "",
};
const EmployeeList = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [addEmployee, setAddEmployee] = useState(initialstate);
  const [employeeListVal, setEmployeeListVal] = useState([]);
  const [flattenedProjects, setFlattenedProjects] = useState([]);
  const [module, setModule] = useState([]);
  const [propData, setPropData] = useState({});
  const [Permission, setPermission] = useState();
  const [searchText, setSearchText] = useState("");
  const [sortedInfo, setSortedInfo] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [designation, setDesignation] = useState([]);
  // idp mode: people come from HRMS and passwords live only in the company login.
  const [isIdpMode, setIsIdpMode] = useState(false);

  useEffect(() => {
    fetchAuthMode().then((mode) => setIsIdpMode(mode === "idp"));
  }, []);
  const { userInfo } = useSelector((state) => state.userDetails);
  const dispatch = useDispatch();
  const notify = (error) => toast.error(error);
  const notifySuccess = (msg) => toast.success(msg);
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const location = useLocation();
  const val = location?.pathname;
  const { request } = useFetch();
  const str = val.replace("/", "");
  const navigate = useNavigate();

  const getUserList = async () => {
    try {
      const response = await request("/users-list-all", "get", null, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        setEmployeeListVal(response?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (value) => {
    console.log(value);

    const formData = new URLSearchParams();
    formData.append("firstname", value?.firstname);
    formData.append("lastname", value?.lastname);
    formData.append("role_id", 0);
    formData.append("email", value?.email);
    formData.append("contactnumber", value?.contactnumber);
    if (!isIdpMode) formData.append("password", value?.password);
    formData.append("company_id", 0);
    formData.append("department_id", 0);
    formData.append("module_id", value?.module);
    formData.append("designation_id", value?.designation);
    formData.append("jobgrade_id", 0);
    formData.append("reporting_mngr_id", 0);
    formData.append("unit_id", 0);
    try {
      await form.validateFields();

      const response = await request("/user-add", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        notifySuccess(response?.data?.message);
        form.resetFields();
        setAddEmployee(initialstate);
        setOpenDrawer(false);
        dispatch(
          userInfoAction({
            ...userInfo,
            user_limit: userInfo.user_limit - 1,
          })
        );
        await getUserList();
      } else {
        notify(response?.response?.data?.message);
      }
    } catch (error) {
      console.log(error, "api error");
    }
  };

  const handleUserActive = async (id) => {
    const formData = new URLSearchParams();
    formData.append("userid", id);
    try {
      const response = await request("/user-status", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status == 1) {
        getUserList();
      } else {
        // e.g. idp mode: reactivating a person no longer in HRMS.
        notify(response?.response?.data?.message);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };
  const getDirPermission = (val) => {
    // setPermission(val)
    navigate(ROUTES.DIRECTORYPERMISSIONS.replace(":id", val?.id));
  };
  const filteredData = flattenedProjects
    ?.filter((item) => {
      return Object.values(item).some((value) => String(value).toLowerCase().includes(searchText.toLowerCase()));
    })
    ?.map((item, index) => ({
      ...item,
      // srNo: pageSize * (currentPage - 1) + index + 1,
    }));

  const showModal = (record) => {
    getPropData(record);
  };

  const PermissionAllow = (record) => {
    getPermission(record);
    localStorage.setItem("userFullName", record?.userfullname);
  };

  const columns = [
    {
      title: "S.NO",
      key: "index",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
      sorter: (a, b) => a.srNo - b.srNo,
      sortOrder: sortedInfo.columnKey === "srNo" && sortedInfo.order,
      width: 120,
      align: "center",
    },
    {
      title: "Full Name",
      dataIndex: "full_name",
      key: "full_name",
      align: "center",
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      align: "center",
    },

    {
      title: "Contact Number",
      key: "contact",
      dataIndex: "contact",
      align: "center",
    },

    {
      title: "User Status",
      key: "active",
      dataIndex: "active",
      align: "center",
    },
    {
      title: "ACTIONS",
      key: "action",
      dataIndex: "action",
      align: "center",
      render: (_, record) => (
        <Dropdown
          placement="bottomRight"
          overlay={
            <Menu className="bd_tableAction">
              <Menu.Item key="edit" onClick={() => showModal(record)} className="bd_view_btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                  />
                </svg>
                Edit
              </Menu.Item>
              <Menu.Item key="role" onClick={() => PermissionAllow(record)} className="bd_view_btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-key"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8m4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5" />
                  <path d="M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                </svg>
                Role Permissions
              </Menu.Item>
              {/* 
              <Menu.Item key="drPermission" onClick={() => {
                getDirPermission(record);
                console.log(record)
              }} className='bd_view_btn'>
                <svg width="24" height="24" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#icon-bb3d6d4d91d71d5)"><circle cx="15" cy="33" r="8" stroke="#000" strokeWidth="3" /><path d="M29 16L36 22" stroke="#000" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /><path d="M20 26L36 8L43 14" stroke="#000" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></g><defs><clipPath id="icon-bb3d6d4d91d71d5"><rect width="48" height="48" fill="#000" /></clipPath></defs></svg>
                Directory Permissions
              </Menu.Item> */}
            </Menu>
          }
        >
          <a onClick={(e) => e.preventDefault()}>
            <More theme="outline" size="25" fill="#95a6b6" strokeWidth={3} />
          </a>
        </Dropdown>
      ),
    },
  ];

  useEffect(() => {
    const flattenedData = (employeeListVal || []).map((project) => ({
      key: project.id,
      row_id: project?.id,
      full_name: project?.userfullname,
      created_by: project?.createdby_username?.userfullname || "Unknown",
      email: project?.email || "No Email",
      contact: project?.contactnumber || "No Contact",
      active:
        project?.permanent_sys_adm == 2 ? (
          <Switch checked={project?.isactive ? true : false} onClick={() => handleUserActive(project?.id)} />
        ) : (
          "Admin"
        ),
      ...project,
    }));

    setFlattenedProjects(flattenedData);
  }, [employeeListVal]);

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const getPropData = (val) => {
    setPropData(val);
    navigate(ROUTES.EMP_PROFILE.replace(":id", val?.id));
  };

  const getPermission = (val) => {
    setPermission(val);
    navigate(ROUTES.ROLEPERMISSIONS.replace(":id", val?.id));
  };

  const predefinedValues = () => {
    let newObj = {
      firstname: propData?.firstname || "",
      lastname: propData?.lastname || "",
      company_id: propData?.company_id || "",
      email: propData?.email || "",
      contactnumber: propData?.contactnumber || "",
      password: propData?.password || "",
      country_id: propData?.country_id || "",
      state_id: propData?.state_id || "",
      city_id: propData?.city_id || "",
      date_of_birth: propData?.date_of_birth !== null ? dayjs(propData?.date_of_birth) : null,
      full_address_1: propData?.full_address_1 || "",
      zip_code: propData?.zip_code || "",
      profileimg: propData?.profileimg || "",
    };
    setAddEmployee((prevState) => {
      return {
        ...prevState,
        ...newObj,
      };
    });
    form.setFieldsValue(newObj);
  };

  const handleReset = () => {
    form.resetFields();
    setAddEmployee(initialstate);
  };

  useEffect(() => {
    if (propData?.id) {
      predefinedValues();
    }
  }, [propData]);

  const handleKeyPress = (e) => {
    const alphabeticChars = /[a-zA-Z]/;
    const forbiddenChars = /[{}.\[\]""''`~;:,0-9\-_@#$%^&*()<>?/|+=!\\]/;
    if (forbiddenChars.test(e.key) && alphabeticChars.test(e.key)) {
      e.preventDefault();
    } else if (e.key === "Enter") {
      e.preventDefault();
      //  handleProjectInfo()
    } else if (e.key === " " && e.target.selectionStart === 0) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    getUserList();
  }, []);

  const validateStrongPassword = (_, value) => {
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;
    const numericRegex = /[0-9]/;
    const specialCharacterRegex = /[^A-Za-z0-9]/;
    const minLength = 8;
    const maxLength = 16;

    if (!value) {
      return Promise.reject("Password is required");
    }

    if (value.length < minLength) {
      return Promise.reject(`Password must be at least ${minLength} characters long`);
    }

    if (value.length > maxLength) {
      return Promise.reject(`Password must not exceed ${maxLength} characters`);
    }

    if (!lowercaseRegex.test(value)) {
      return Promise.reject("Password must contain at least one lowercase letter");
    }

    if (!uppercaseRegex.test(value)) {
      return Promise.reject("Password must contain at least one uppercase letter");
    }

    if (!numericRegex.test(value)) {
      return Promise.reject("Password must contain at least one number");
    }

    if (!specialCharacterRegex.test(value)) {
      return Promise.reject("Password must contain at least one special character (e.g., !, @, #, $, %, ^, etc.)");
    }

    return Promise.resolve();
  };

  const validateContactNumber = (_, value) => {
    const regex = /^\d{10}$/;

    if (!value || regex.test(value)) {
      return Promise.resolve();
    }

    return Promise.reject("Contact number must be a 10-digit number");
  };
  const handleEmployeeChange = (name, e) => {
    console.log(e);
    let trimmedValue;
    if (name == "designation_id" || name == "module_id") {
      trimmedValue = e;
    } else {
      trimmedValue = e.target.value.trimStart();
    }
    form.setFieldsValue({ [name]: trimmedValue });
    form2.setFieldsValue({ [name]: trimmedValue });
  };

  const getModule = async () => {
    try {
      const response = await request("/module-list", "get", null, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        setModule(response?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAddTenderCountry = async () => {
    try {
      const response = await request("/get-designation", "get");

      if (response?.data?.status === "1") {
        setDesignation(response?.data?.data);
      }
    } catch (error) {
      console.log(error, "api erorr");
    }
  };

  useEffect(() => {
    getAddTenderCountry();
    getModule();
  }, []);

  return (
    <>
      <Header />
      <div className="bd_emplist_main">
        <div className="bd_empHeader">
          <div className="bd_emplist_main_header">Employee List</div>
          <button
            className="BG_mainButton"
            onClick={() => {
              setOpenDrawer(true);
            }}
          >
            <AddUser theme="outline" size="22" strokeWidth={3} strokeLinecap="butt" /> Add Employee
          </button>
        </div>
        <div className="tableHead_wrap">
          <Search
            placeholder="Search"
            allowClear
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 340 }}
            onKeyPress={handleKeyPress}
          />
          <div className="showPrPage">
            <span>Showing</span>
            <Select
              suffixIcon={<Down theme="outline" size="18" fill="#747474" />}
              defaultValue={pageSize}
              style={{ width: 70 }}
              onChange={handlePageSizeChange}
            >
              <Option value={10}>10</Option>
              <Option value={20}>20</Option>
              <Option value={30}>30</Option>
              <Option value={40}>40</Option>
            </Select>
            <span>of {filteredData?.length} results</span>
          </div>
        </div>

        <Table
          columns={columns}
          dataSource={filteredData}
          pagination={{
            pageSize: pageSize,
          }}
          scroll={{ x: "max-content" }}
          onChange={(pagination, filters, sorter) => {
            setSortedInfo(sorter);
            setCurrentPage(pagination.current);
          }}
        />
      </div>

      {/* Add Employee Drawer */}

      <Drawer
        closeIcon={<img src={SkipBack} alt="" />}
        title="Add Employee"
        placement="right"
        onClose={() => {
          setOpenDrawer(false);
          handleReset();
        }}
        open={openDrawer}
        width={800}
      >
        <Form form={form} name="control-hooks" layout="vertical" onFinish={handleSubmit}>
          <Row gutter={20}>
            <Col sm={12}>
              <Form.Item
                label="First Name"
                name="firstname"
                rules={[{ required: true, message: "First name is required" }]}
              >
                <Input placeholder="Enter Here" onChange={(e) => handleEmployeeChange("firstname", e)} />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                label="Last Name"
                name="lastname"
                rules={[{ required: true, message: "Last name is required" }]}
              >
                <Input placeholder="Enter Here" onChange={(e) => handleEmployeeChange("lastname", e)} />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Email is required" },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
                // idp mode: only people already added in HRMS can be given access.
                extra={isIdpMode ? "Use the employee's email from HRMS." : undefined}
              >
                <Input onChange={(e) => handleEmployeeChange("email", e)} placeholder="Enter Here" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                label="Contact Number"
                name="contactnumber"
                rules={[
                  { required: true, message: "Contact Number is required" },
                  {
                    validator: validateContactNumber,
                  },
                ]}
              >
                <Input placeholder="Enter Here" type="number" />
              </Form.Item>
            </Col>
            {/* idp mode: passwords live only in the company login (Auth). */}
            {!isIdpMode && (
              <Col sm={12}>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      validator: validateStrongPassword,
                    },
                  ]}
                >
                  <Input placeholder="Enter Here" onChange={(e) => handleEmployeeChange("password", e)} />
                </Form.Item>
              </Col>
            )}
            <Col sm={12}>
              <Form.Item
                label="Designation"
                name="designation"
                rules={[{ required: true, message: "Designation is required" }]}
              >
                <Select
                  showSearch
                  onChange={(value) => handleEmployeeChange("designation_id", value)}
                  value={addEmployee.designation_id}
                  options={designation?.map((item, index) => {
                    return {
                      value: item?.id,
                      label: item?.designation_name,
                    };
                  })}
                  placeholder="Select Designation"
                  suffixIcon={<Down theme="outline" size="18" fill="#747474" />}
                  filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item label="Module" name="module" rules={[{ required: true, message: "module is required" }]}>
                <Select
                  mode="multiple"
                  showSearch
                  onChange={(value) => handleEmployeeChange("module_id", value)}
                  value={addEmployee.module_id}
                  options={module?.map((item, index) => {
                    return {
                      value: item?.id,
                      label: item?.folder_name,
                    };
                  })}
                  placeholder="Select Module"
                  suffixIcon={<Down theme="outline" size="18" fill="#747474" />}
                  filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="bd_drawerFoot">
            <button className="BG_mainButton" onClick={handleReset}>
              Reset
            </button>
            <button className="BG_mainButton">Add</button>
          </div>
        </Form>
      </Drawer>
    </>
  );
};
export default EmployeeList;
